/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BloodResultsStatusDto } from '../models/BloodResultsStatusDto';
import type { GroupedBloodResultDto } from '../models/GroupedBloodResultDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class BloodResultsService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Get blood results for the authenticated patient
     * @returns BloodResultsStatusDto Blood results retrieved successfully
     * @throws ApiError
     */
    public getMyResults(): CancelablePromise<BloodResultsStatusDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/blood-results',
        });
    }

    /**
     * Get blood results for a specific patient (MedStaff only)
     * @param patientId
     * @returns GroupedBloodResultDto Blood results retrieved successfully
     * @throws ApiError
     */
    public getPatientResults(
        patientId: string,
    ): CancelablePromise<Array<GroupedBloodResultDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/blood-results/{patientId}',
            path: {
                'patientId': patientId,
            },
            errors: {
                403: `Forbidden - User is not authorized to access this patient`,
            },
        });
    }

}
